import React, { useEffect, useState } from "react";

export function formatAZN(n) {
  if (n == null) return "—";
  return new Intl.NumberFormat("az-AZ", { maximumFractionDigits: 0 }).format(n) + " ₼";
}

export function useCountdown(endIso) {
  const [ms, setMs] = useState(() => new Date(endIso).getTime() - Date.now());
  useEffect(() => {
    const t = setInterval(() => setMs(new Date(endIso).getTime() - Date.now()), 1000);
    return () => clearInterval(t);
  }, [endIso]);
  return ms;
}

export function CountdownBadge({ endIso, className = "" }) {
  const ms = useCountdown(endIso);
  if (ms <= 0) return <span className={`font-mono text-red-600 font-bold ${className}`} data-testid="countdown-ended">Bitdi</span>;
  const s = Math.floor(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const label = d > 0 ? `${d}g ${h}s ${m}d` : `${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}:${String(sec).padStart(2,"0")}`;
  const urgent = ms < 5 * 60 * 1000;
  return <span className={`font-mono font-bold ${urgent ? "text-red-600" : "text-slate-900"} ${className}`} data-testid="countdown-timer">{label}</span>;
}

export const STATUS_LABELS = {
  draft: "Qaralama",
  pending_payment: "Ödəniş gözlənilir",
  scheduled: "Planlaşdırılıb",
  active: "Aktiv",
  ended_pending_seller: "Qərar gözlənilir",
  accepted: "Satış təsdiqləndi",
  rejected: "Satılmadı",
  cancelled: "Ləğv edildi",
};

export const STATUS_STYLE = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  scheduled: "bg-blue-50 text-blue-700 border-blue-200",
  ended_pending_seller: "bg-amber-50 text-amber-700 border-amber-200",
  accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-slate-100 text-slate-700 border-slate-200",
  pending_payment: "bg-orange-50 text-orange-700 border-orange-200",
  cancelled: "bg-red-50 text-red-700 border-red-200",
};
